/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.CancellationSource_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.CancellationSource domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum CancellationSource_ {
   /// <summary>
   ///   Self Service (selfsvc)
   /// </summary>
   SelfService = 1,
   /// <summary>
   ///   Customer Service (custsvc)
   /// </summary>
   CustomerService = 2,
   /// <summary>
   ///   Billing Policy (billpol)
   /// </summary>
   BillingPolicy = 3
}

export const CancellationSources: CancellationSource[] = [
   {
      code: CancellationSource_.SelfService,
      literal: 'SelfService',
      description: 'Self Service',
      shortDescription: 'selfsvc',
      listPriority: 0,

      typeName: "CancellationSource"
   },
   {
      code: CancellationSource_.CustomerService,
      literal: 'CustomerService',
      description: 'Customer Service',
      shortDescription: 'custsvc',
      listPriority: 0,

      typeName: "CancellationSource"
   },
   {
      code: CancellationSource_.BillingPolicy,
      literal: 'BillingPolicy',
      description: 'Billing Policy',
      shortDescription: 'billpol',
      listPriority: 0,

      typeName: "CancellationSource"
   }
]

export class CancellationSource implements IDomainModel {
   code: CancellationSource_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: CancellationSource_): CancellationSource {
      return CancellationSources.find(d => d.code === code)
   }
}
